
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summary/[summary_id]",
      function () {
        return require("private-next-pages/summary/[summary_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summary/[summary_id]"])
      });
    }
  